import { render, staticRenderFns } from "./DspTagListGrid.vue?vue&type=template&id=9951b128"
import script from "./DspTagListGrid.vue?vue&type=script&lang=js"
export * from "./DspTagListGrid.vue?vue&type=script&lang=js"
import style0 from "./DspTagListGrid.vue?vue&type=style&index=0&id=9951b128&prod&lang=css"
import style1 from "./DspTagListGrid.vue?vue&type=style&index=1&id=9951b128&prod&lang=scss"
import style2 from "./DspTagListGrid.vue?vue&type=style&index=2&id=9951b128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports